import { API_ENDPOINTS } from "./Constants";
import { apiFetch } from "./apiHelper";

export async function getAppSettings() {
    const res = await apiFetch(API_ENDPOINTS.APP_SETTINGS, { credentials: "include" });
    if (!res.ok) throw new Error("Greška pri dohvaćanju postavki");
    return res.json();
}

export async function updateAppSetting(key, value) {
    const res = await apiFetch(`${API_ENDPOINTS.APP_SETTINGS}/${key}`, {
        method: "PUT",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ value }),
    });
    if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.message || "Greška pri ažuriranju postavke");
    }
    return res.json();
}
